module.exports = __webpack_public_path__ + "img/frame (13).5867aa9d.jpg";